document.addEventListener("DOMContentLoaded", () => {

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const burger = document.querySelector(".js-burger");
  const menu   = document.querySelector(".js-header-nav");
  if (burger && menu) {
    burger.addEventListener("click", () => {
      const open = menu.classList.toggle("active");
      burger.classList.toggle("active", open);
      document.body.classList.toggle("locked", open);
    });
    window.addEventListener("resize", () => {
      if (window.innerWidth > 992) {
        menu.classList.remove("active");
        burger.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Search overlay ───────────────────────────────────────────────────────
  const openSearchBtn  = document.querySelector(".js-open-search");
  const closeSearchBtn = document.querySelector(".js-close-search");
  const searchOverlay  = document.querySelector(".js-search-overlay");
  if (openSearchBtn && closeSearchBtn && searchOverlay) {
    openSearchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      searchOverlay.classList.add("active");
      document.body.classList.add("locked");
      setTimeout(() => {
        const input = searchOverlay.querySelector("input");
        if (input) input.focus();
      }, 100);
    });
    closeSearchBtn.addEventListener("click", () => {
      searchOverlay.classList.remove("active");
      document.body.classList.remove("locked");
    });
    searchOverlay.addEventListener("click", (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove("active");
        document.body.classList.remove("locked");
      }
    });
  }

  // ─── Hero magazine slider ─────────────────────────────────────────────────
  if (document.querySelector(".js-hero-slider")) {
    new Swiper(".js-hero-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: ".js-hero-slider .swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-hero-slider .swiper-button-next",
        prevEl: ".js-hero-slider .swiper-button-prev",
      },
    });
  }

  // ─── Featured slider 1 (fade) ─────────────────────────────────────────────
  if (document.querySelector(".featured-slider_1")) {
    new Swiper(".featured-slider_1", {
      loop: false,
      effect: "fade",
      pagination: {
        el: ".featured-slider_1 .swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".featured-slider_1 .swiper-button-next",
        prevEl: ".featured-slider_1 .swiper-button-prev",
      },
    });
  }

  // ─── Featured slider 2 (multi-slide) ─────────────────────────────────────
  if (document.querySelector(".featured-slider_2")) {
    new Swiper(".featured-slider_2", {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 15,
      breakpoints: {
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
      },
      navigation: {
        nextEl: ".featured-slider_2 .swiper-button-next",
        prevEl: ".featured-slider_2 .swiper-button-prev",
      },
    });
  }

});
